export enum SegmentFeedTypes {
  Newest = 'Newest',
  Static = 'Static',
}
